// src/components/SearchTable.js
import React from 'react';
import DataTable from 'react-data-table-component';
import { useTheme } from "@chakra-ui/react";

const SearchTable = ({ columns, data }) => {
  const theme = useTheme(); // Access the theme
  const customStyles = {
    header: {
      style: {
        fontSize: '22px',
        fontWeight: 'normal',
        color: '#ffffff',
        backgroundColor: theme.colors.tableHeader,
      },
    },
    headCells: {
      style: {
        fontSize: '16px',
        fontWeight: 'normal',
        color: '#ffffff',
        backgroundColor: theme.colors.tableHeader,
      },
    },
    cells: {
      style: {
        fontSize: '14px',
      },
    },
  };

  return (<>
    <DataTable
      columns={columns}
      data={data}
      pagination
      highlightOnHover
      pointerOnHover
      customStyles={customStyles}
    />
  </>
  );
};

export default SearchTable;
